import React from "react";
import Link from "gatsby-link";
import styled from "styled-components";
import FlexColumn from "./FlexColumn";
import Heart from "./SVG/Heart";

const Container = styled.div`
  background: #181818;
  margin-bottom: 1.45rem;
`;

const HeaderFlexContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;

  margin: 0 auto;
  max-width: 960px;
  padding: 0.6rem 1.9875rem;
`;

const HeaderLogo = styled.h1`
  margin: 0.5rem;

  .heart {
    transform: translate(0, 6px);

    fill: rgb(255, 82, 82);
  }
`;

const DateDiv = styled.div`
  color: white;
  font-size: 1.1rem;
  font-weight: 700;
  text-align: center;
`;

const StyledLogoLink = styled(Link)`
  color: white;
  text-decoration: none;

  :hover {
    color: white;
  }
`;

const LinksFlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  flex-grow: 1;

  margin: 0.5rem;
`;

const HeaderLink = styled(Link).attrs({ activeClassName: "active" })`
  margin: 0.8rem;
  color: white;
  transition: color 0.3s ease-in-out;
  text-decoration: none;

  :hover {
    transition: color 0.3s ease-in-out;
    color: rgb(255, 82, 82);
  }

  &.active {
    color: rgb(255, 82, 82);
  }
`;

const Header = () => (
  <Container>
    <HeaderFlexContainer>
      <FlexColumn>
        <HeaderLogo>
          <StyledLogoLink to="/">
            Adam <Heart /> Casey
            <DateDiv>8/18/2018</DateDiv>
          </StyledLogoLink>
        </HeaderLogo>
      </FlexColumn>
      <LinksFlexContainer>
        <div>
          <HeaderLink to="/our-story">Our Story</HeaderLink>
        </div>
        <div>
          <HeaderLink to="/whats-happening">What's Happening?</HeaderLink>
        </div>
        <div>
          <HeaderLink to="/rsvp">RSVP</HeaderLink>
        </div>
      </LinksFlexContainer>
    </HeaderFlexContainer>
  </Container>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js